import { Grid, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import ThemeBtn from "../../../Common/ThemeBtn";
import ThemeContext from "../../../context";
import useGetTransferPositions from "../../hooks/useGetTransferPositions";
import useCheckSelectedPositions from "../hooks/useCheckSelectedPositions";

// ----------------------------------------------------------------------

export const RevisionRowBtn = () => {
	const { actions, subproduct, theme } = useContext(ThemeContext);

	const { positions } = useGetTransferPositions();
	const { isDisabled } = useCheckSelectedPositions();

	const { translate } = useLocales();

	const title = translate(
		`Selecciona los ${subproduct === "FUND" ? "fondos" : "planes"} que quieras traspasar a VUMI`
	);

	return (
		<Grid container sx={{ my: 1 }} justifyContent='space-between' alignItems='center' gap={2}>
			<Grid item>
				<Typography variant='subtitle1' color={theme?.colors.primaryText}>
					{title}
				</Typography>
			</Grid>
			{positions.length !== 0 && (
				<Grid item>
					<ThemeBtn
						variant='contained'
						color='primary'
						sx={{ minWidth: 120 }}
						onClick={() => actions.setStep(5)}
						disabled={isDisabled}
						title={translate("Ir a revisión")}
					/>
				</Grid>
			)}
		</Grid>
	);
};

export default RevisionRowBtn;
